/**
 * @generated SignedSource<<cca183f3e7fe3ce0aebfb443b2993ca9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type processDefinitionQueryIncidentsQuery$variables = {
  definitionId: string;
};
export type processDefinitionQueryIncidentsQuery$data = {
  readonly getProcessDefinitionIncidents: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"processDefinitionQueryIncidentFragment">;
  }> | null | undefined;
};
export type processDefinitionQueryIncidentsQuery = {
  response: processDefinitionQueryIncidentsQuery$data;
  variables: processDefinitionQueryIncidentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "definitionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "definitionId",
    "variableName": "definitionId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "processDefinitionQueryIncidentsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProcessDefinitionIncident",
        "kind": "LinkedField",
        "name": "getProcessDefinitionIncidents",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "processDefinitionQueryIncidentFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "processDefinitionQueryIncidentsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProcessDefinitionIncident",
        "kind": "LinkedField",
        "name": "getProcessDefinitionIncidents",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "processDefinitionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "processInstanceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activityId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "failedActivityId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "incidentMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "incidentType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "incidentTimestamp",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9d3dc93637050b235dcdc82f31592d8d",
    "id": null,
    "metadata": {},
    "name": "processDefinitionQueryIncidentsQuery",
    "operationKind": "query",
    "text": "query processDefinitionQueryIncidentsQuery(\n  $definitionId: String!\n) {\n  getProcessDefinitionIncidents(definitionId: $definitionId) {\n    ...processDefinitionQueryIncidentFragment\n  }\n}\n\nfragment processDefinitionQueryIncidentFragment on ProcessDefinitionIncident {\n  processDefinitionId\n  processInstanceId\n  activityId\n  failedActivityId\n  incidentMessage\n  incidentType\n  incidentTimestamp\n}\n"
  }
};
})();

(node as any).hash = "0cadfb79bc0fd4ec067c99525aba7dda";

export default node;
